import { motion } from "framer-motion";

// Simple scroll-reveal wrapper
export const Reveal = ({ children, delay = 0, y = 40, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

// Overline label (uppercase, wide tracking)
export const Overline = ({ children, className = "" }) => (
  <span
    className={`inline-block font-body text-xs sm:text-sm uppercase tracking-overline text-[#2D46A0] ${className}`}
  >
    {children}
  </span>
);

// Masked line-by-line reveal for hero headings
export const MaskedLines = ({ lines, className = "", startDelay = 0.2 }) => (
  <span className="block">
    {lines.map((line, i) => (
      <span key={i} className="reveal-mask">
        <motion.span
          className={`block ${className}`}
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{
            duration: 0.9,
            delay: startDelay + i * 0.12,
            ease: [0.22, 1, 0.36, 1],
          }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);
